<template>

<div>
  <div class="row">
    <div class="form-group col-lg-6">
      <label for="board">{{ $t('board') }}</label>
      <input
        type="text"
        id="board"
        name="board"
        class="form-control"
        :placeholder="$t('ph_board')"
        :value="board"
        @input="event => board = event.target.value.toUpperCase()"
        v-validate="'max:8|regex:[A-Z]{3}-{1}[0-9]{1}[0-9A-Z]{1}[0-9]{2}'"
        maxlength="8"
      >
    </div>

    <div class="form-group col-lg-6">
      <label for="date">{{ $t('date') }}</label>
      <input
        type="date"
        id="date"
        name="date"
        class="form-control"
        :placeholder="$t('ph_date')"
        v-model="date"
      >
    </div>    
  </div>

  <LoaderButton
    id="search"
    @click="getDataRead"
  >
    {{ $t('search') }}
  </LoaderButton>

  <div class="row">
    <div class="form-group col-lg-6">
      <label for="offset">{{ $t('Offset') }}</label>
      <input
        type="text"
        id="offset"
        name="offset"
        class="form-control"
        :placeholder="$t('ph_offset')"
        v-model="offset"
      >
    </div>
  </div>

  <LoaderButton
    id="search"
    @click="setOffset"
  >
    {{ $t('save') }}
  </LoaderButton>

  <div class="row">
    <div class="col-12">
      <b-table
        responsive='xl'
        bordered
        hover
        class="bg-white"
        :items="dataRead"
        :fields='fieldsDataRead'
      />
    </div>
  </div>
</div>

</template>

<script>
import LoaderButton from '@/components/button/LoaderButton'
import moment from 'moment-timezone'
import { request } from '@/lib/http'

export default {
  name: 'PositionsAndOffset',
  components: {
    LoaderButton
  },

  data () {
    return {
      board: '',
      date: '',
      fieldsDataRead: [
        {
          key: 'timestamp',
          label: this.$t('server_hour'),
          formatter: (value, key, item) => {            
            return value
              ? moment(value).tz('America/Recife').add(3, 'hours').format('DD/MM/YYYY HH:mm:ss')
              : ''
          }
        },
        {
          key: 'datetime',
          label: this.$t('gps_hour'),
          formatter: (value, key, item) => {            
            return value
              ? moment(value).tz('America/Recife').format('DD/MM/YYYY HH:mm:ss')
              : ''
          }
        },
        {
          key: 'id',
          label: this.$t('gps_hour_with_offset'),
          formatter: (value, key, item) => moment(item.datetime).add(this.offset * 1, 'days').format('DD/MM/YYYY HH:mm:ss')
        },
        {
          key: 'gprs',
          label: 'GPRS',
          formatter: (value, key, item) => {
            return value
              ? 'SIM'
              : 'NÃO'
          }
        },
        {
          key: 'gps',
          label: 'GPS',
          formatter: (value, key, item) => {
            return value
              ? 'SIM'
              : 'NÃO'
          }
        },
        {
          key: 'latitude',
          label: this.$t('lat/lon'),
          formatter: (value, key, item) => {
            return value
              ? value + '/' + item.longitude
              : ''
          }
        }
      ],
      dataRead: [],
      offset  : '7168',
      dateToSetOffset: ''
    }
  },

  watch: {
    board: function(value) {
      // Define máscara da placa
      if (window.event.inputType === 'deleteContentBackward') {
        return
      }

      if (value.length === 3){
        this.board = value + '-'
      }

      if (value.length === 4 && !value.includes('-')) {
        this.board = value.substr(0,3)+"-"+value.substr(3)
      }
    }
  },

  methods: {
    async getDataRead() {
      const { dispatch } = this.$store

      if (!this.date || !this.board) {
        return dispatch('notify/error', { message: 'É necessário informar a placa e data' })
      }

      dispatch('overlay/show', true)

      try {
        this.dataRead = await request({
          url   : 'data-read',
          method: 'get',
          params: {
            board: this.board,
            date : this.date
          }
        })

        this.dateToSetOffset = this.date
      } catch (error) {
        dispatch('notify/error', { message: error.message })
      } finally {
        dispatch('overlay/show', false)
      }
        
    },

    async setOffset() {
      const { dispatch } = this.$store

      dispatch('overlay/show', true)

      try {
        await request({
          url   : `data-read/${this.dataRead[0].vehicleId}`,
          method: 'patch',
          params: {
            offset: this.offset,
            date  : this.dateToSetOffset
          }
        })

      } catch (error) {
        console.log(error)
      } finally {
        dispatch('overlay/show', false)
        $('#search').trigger('click')
      }

    }
  },
}
</script>